import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import HomePage from './components/home/HomePage';
import MenuPageNew from './components/menu/MenuPageNew';
import EditMenuPage from './components/menu/admin/EditMenuPage';
import './App.css';
import Logout from './components/common/Logout';
import AboutPage from './components/gallery/AboutPage';
import TerminiCondizioniPage from './components/common/TerminiCondizioniPage';
import PrivacyPolicyPage from './components/common/PrivacyPolicyPage';
import ScrollToTop from './components/common/ScrollToTop';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HelmetProvider } from 'react-helmet-async';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from './firebase'; // Assumi che tu abbia già configurato Firebase
import ErrorIcon from '@mui/icons-material/Error'; 

function App() {
  const [toastMessages, setToastMessages] = useState([]);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    AOS.refresh();
  }, []);

  useEffect(() => {
    const adminSettingsRef = doc(db, 'adminSettings', 'global');

    // Usa onSnapshot per ottenere aggiornamenti in tempo reale
    const unsubscribe = onSnapshot(adminSettingsRef, (doc) => {
      if (doc.exists()) {
        const data = doc.data();
        console.log('data',data);
        setToastMessages(data.fieldsets || []); 
      }
    });

    // Cleanup: unsubscribe quando il componente viene smontato
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (toastMessages?.length) {
      toastMessages.forEach(fieldset => {
        toast(fieldset.message, {
          position: 'top-right',
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: 'colored',
        icon: <ErrorIcon style={{ color: '#fff' }} />,
        closeButton: (
          <button className='toastify-close-btn'>✕</button>
        ),
        className: 'custom-toast', 
        style: {
          backgroundColor: fieldset.messageColor,
          color: '#fff',
        },
      });
    })
    }
  }, [toastMessages]);

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ToastContainer />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/menu" element={<MenuPageNew />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/terminiCondizioni" element={<TerminiCondizioniPage />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicyPage />} />
            <Route path="/admin" element={<EditMenuPage />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/menu-.html" element={<Navigate to="/menu" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
